//themes.js

export const theme = {
  primaryDark: "#0D0C1D",
  primaryLight: "#EFFFFA",
  primaryHover: "#e197b9",
  mobile: "576px",
};
